import React from 'react';
import Popup from '../User/popup';
import { MaintenanceCalendar } from './MaintenanceCalendar';

const MaintenanceCalendarDialog = ({ show, onClose, selectedDate, onSelect, subServiceID }) => {

    return (
        <Popup show={show}>
            <div className="calendar-popup-container relative w-full max-w-[95vw] md:max-w-4xl m-auto bg-white rounded-[3rem] overflow-hidden shadow-2xl animate-pop-in">
                <button
                    onClick={onClose}
                    className="absolute top-6 right-6 text-5xl hover:bg-gray-100 rounded-full w-14 h-14 flex items-center justify-center transition-all active:scale-90 z-[100]"
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>

                <div className="p-4 md:p-10 pt-16">
                    <MaintenanceCalendar
                        selectedDate={selectedDate}
                        onSelect={(date) => {
                            onSelect(date);
                            onClose();
                        }}
                        subServiceID={subServiceID}
                    />
                </div>
            </div>
            <style jsx>{`
                @keyframes pop-in {
                    from { opacity: 0; transform: scale(0.95) translateY(20px); }
                    to { opacity: 1; transform: scale(1) translateY(0); }
                }
                .animate-pop-in {
                    animation: pop-in 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
                }
                .calendar-popup-container {
                     max-height: 95vh;
                     overflow-y: auto;
                }
                .calendar-popup-container::-webkit-scrollbar {
                    width: 6px;
                }
                .calendar-popup-container::-webkit-scrollbar-thumb {
                    background: rgba(0,0,0,0.1);
                    border-radius: 10px;
                }
            `}</style>
        </Popup>
    );
};

export default MaintenanceCalendarDialog;
